import Card from "@/components/Card";
import { Box, styled, Typography } from "@mui/material";
import { StyledDivider } from "@/components/styled";
import BalanceActivity from "@/components/TotalBalance/BalanceActivity.tsx";
import AddFunds from "@/components/TotalBalance/AddFunds.tsx";
import DeductFunds from "@/components/TotalBalance/DeductFunds.tsx";
import TransferFunds from "@/components/TotalBalance/TransferFunds.tsx";
import { useBudgetStore } from "@/store/budgetStore.ts";
import { formatMWh } from "@/utils/formatMWh.ts";
import { useEffect, useState } from "react";
import ExportTransactions from "@/components/TotalBalance/ExportTransactions.tsx";

const BoxActions = styled(Box)(() => ({
  display: "flex",
  gap: "16px",
  marginTop: "16px",
  flexDirection: "column",
}));

const TotalBalance = () => {
  const budgetData = useBudgetStore((state) => state.budgetData);
  const [yScroll, setYScroll] = useState(0);

  useEffect(() => {
    // calculate dynamic Y scroll height for table
    setYScroll(window.innerHeight - 160);
  }, []);

  return (
    <Card
      title={"Total balance"}
      sx={{ maxHeight: `${yScroll}px`, position: "relative", paddingBottom: 0 }}
    >
      <Typography
        data-testid="total-balance-amount"
        variant={"h3"}
        sx={{
          overflowX: "hidden",
          textOverflow: "ellipsis",
          minHeight: "35px",
        }}
      >
        {formatMWh(budgetData?.total || 0)}
      </Typography>
      <BoxActions sx={{ ...{ flexDirection: "row" } }}>
        <AddFunds />
        <DeductFunds />
        <TransferFunds />
      </BoxActions>
      <StyledDivider sx={{ marginY: "24px" }} />
      <BalanceActivity />
      <ExportTransactions />
    </Card>
  );
};

export default TotalBalance;
